/**
 * Updates the `instance`'s data with the given `updates`.
 * Resets the `changed` property to an empty object.
 * @param  {Instance} instance
 * @param  {Object} updates
 * @returns {Instance}
 */
function updateDataReduxUtil (instance, updates) {
  return {
    ...instance,
    data: {
      ...instance.data,
      ...updates
    },
    changed: {}
  }
}

export {
  updateDataReduxUtil
}
